import React from 'react'
import './Main.css'
import Header from '../Header/Header'
import HeaderDash from '../../components/Admin/HeaderDash/HeaderDash'
import ProductosMain from '../../components/Admin/ProductosMain/ProductosMain'
import UsuariosMain from '../../components/Admin/UsuariosMain/UsuariosMain'
import CardsCantidad from '../../components/Admin/CardsCantidad/CardsCantidad'
import InfoUserMain from '../../components/Admin/InfoUserMain/InfoUserMain'
export default function Main() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='containerMain'>
                    <div className='deFLexMain'>
                        <CardsCantidad />
                        <UsuariosMain />
                    </div>
                    <div className='deFLexMain'>
                        <ProductosMain />
                        <InfoUserMain />
                    </div>


                </div>
            </section>
        </div>
    )
}
